import { render } from "./Magnifier.vue?vue&type=template&id=a4021e88&scoped=true"
import script from "./Magnifier.vue?vue&type=script&lang=js"
export * from "./Magnifier.vue?vue&type=script&lang=js"

import "./Magnifier.vue?vue&type=style&index=0&id=a4021e88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4021e88"]])

export default __exports__